import { Contact } from '../../../models/contact';
import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { Observable } from 'rxjs';

export class ContactsData implements DataSource<Contact> {

    constructor(private source$: Observable<Contact[]>) {
    }

    connect(collectionViewer: CollectionViewer): Observable<Contact[]> {
        return this.source$;
    }

    disconnect(collectionViewer: CollectionViewer): void {
    }

}

